export default __webpack_public_path__ + "static/back-office-presentation-kz-249f56dddcada3e005ed794ac145d964.png";